module.exports = __webpack_public_path__ + "static/media/a1a3.bb045bc5.jpg";